import React, { Fragment } from 'react';
import { Badge } from 'components/common';
import PropTypes from 'prop-types';

const BookingEmployeeCodeBadgeRenderer = (props) => {

  const {employees} = props.data

  const employeeCode = employees && employees.map((emp, index) => (
    <Badge variant='info' size='sm' key={index} className='tw-mr-1'>{emp.hr_code}</Badge>
  ))

  return (
    <Fragment>
      {employeeCode}
    </Fragment>
  );
};

BookingEmployeeCodeBadgeRenderer.propTypes = {
  data: PropTypes.object
};

export default BookingEmployeeCodeBadgeRenderer;
